

varying vec2 vUv;
uniform float uOpacity;

void main() {
    gl_FragColor = vec4(0.0, 0.0, 0.0, clamp(uOpacity, 0.0, 1.0));
}


